import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryVariables = Types.Exact<{
  gateWayDeviceConnectionId: Types.Scalars['UUID'];
}>;


export type GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery = { deviceHeartbeatCurrentValues?: Maybe<{ __typename?: 'DeviceHeartbeatCurrentValueCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'DeviceHeartbeatCurrentValue', utcTimeMeasured: string }>> }> };


export const GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdDocument = gql`
    query getDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionId($gateWayDeviceConnectionId: UUID!) {
  deviceHeartbeatCurrentValues(where: {deviceId: {eq: $gateWayDeviceConnectionId}}, order: {utcTimeMeasured: DESC}) {
    totalCount
    items {
      utcTimeMeasured
    }
  }
}
    `;

/**
 * __useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery__
 *
 * To run a query within a React component, call `useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery({
 *   variables: {
 *      gateWayDeviceConnectionId: // value for 'gateWayDeviceConnectionId'
 *   },
 * });
 */
export function useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery, GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery, GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryVariables>(GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdDocument, options);
      }
export function useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery, GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery, GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryVariables>(GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdDocument, options);
        }
export type GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryHookResult = ReturnType<typeof useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery>;
export type GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdLazyQueryHookResult = ReturnType<typeof useGetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdLazyQuery>;
export type GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryResult = Apollo.QueryResult<GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQuery, GetDeviceHeartbeatCurrentValuesByGatewayDeviceConnectionIdQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
